import React, { useContext } from 'react';
import RocTitle from '../RocTitle';
import EditContext from './EditContext';
import { getCurrentTenantBaseUrl } from '~/features/tenants/helpers/TenantHelper';

/**
 * Displays a print view action that opens a dedicated print page in a new tab.
 * The print page is responsible for loading content and invoking browser print.
 */
export default function EditPrintViewButton() {
	const { entityDefinition, editingId } = useContext(EditContext);

	if (!editingId) {
		return null;
	}

	const href = `${getCurrentTenantBaseUrl() || ''}${entityDefinition.basePrintRoute}/${editingId}`;

	return (
		<div className="edit-form__actions-bar-item">
			<RocTitle label="Print view" alignment="left">
				<a
					href={href}
					target="_blank"
					rel="noopener noreferrer"
					className="btn btn-outline-primary btn-medium"
					data-testid="print-view-button"
				>
					Print
				</a>
			</RocTitle>
		</div>
	);
}
